import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import api, { apiActionWithRoute, apiAction } from '../../api'
import { Loading, Error } from  '../../components'

const mapDispatchToProps = (dispatch, { entityName } ) => ({
  getRecipe: entityId => dispatch(apiActionWithRoute(api.getRecipe)(entityId)()),
  getRecipeVariants: entityId => dispatch(apiActionWithRoute(api.getRecipeVariants)(
    `${entityId}/recipes`,
  )()),
  fetchLocales: () => dispatch(apiAction(api.getLocales)()),
  fetchTags: () => dispatch(apiAction(api.getTags)()),
  fetchIngredients: ids => dispatch(apiAction(api.getRecipeIngredients)({ ...(ids ? { ids, limit: 500 } : { limit: 5 })  })),
  fetchLabelLevels: type =>
    dispatch(apiActionWithRoute(api.getDefaultLabelLevels)(type)(null, { quite: true, defaultLocale: 1 })),
  fetchAppliances: () => dispatch(apiAction(api.getAppliances)()),
  fetchRegions: () => dispatch(apiAction(api.getRegions)()),
  fetchUnits: () => dispatch(apiAction(api.getUnits)()),
  fetchApplianceTypes: () => dispatch(apiAction(api.getApplianceTypes)()),
})

const getIngredientsIds = variants => {
  const result = {}
  variants.forEach(variant => {
    (variant.sections || []).forEach(section => {
      section.ingredients.forEach(ingredient => {
        result[ingredient.ingredientID] = true
        if(ingredient.hasReplacement && ingredient.replacements) {
          ingredient.replacements.forEach(replacement => {
            result[replacement.ingredientID] = true
          })
        }
      })
    })
  })

  return Reflect.ownKeys(result).join(',')
}

const RecipeLoader = connect(null, mapDispatchToProps)(
  ({ recipeId, getRecipe, getRecipeVariants,
    fetchLocales, fetchLabelLevels, fetchTags, fetchIngredients, fetchAppliances, fetchRegions,
    fetchUnits,
    component,
    fetchApplianceTypes,
  }) => {
    const isNew = recipeId === 'new'

    const [loaded, setLoaded] = useState(false)
    const [requiermentsFetched, setRequiermentsFetched] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [recipeFetched, setRecipeFetched] = useState(false)

    useEffect(() => {
      (async () => {
        if(!hasError) {
          try {
            if (!requiermentsFetched) {
              await fetchLocales()
              await fetchTags()
              await fetchAppliances()
              await fetchRegions()
              await fetchUnits()
              await fetchLabelLevels('browning')
              await fetchLabelLevels('cooking')
              await fetchApplianceTypes()
              setRequiermentsFetched(true)
            }
            if (!isNew && requiermentsFetched && !recipeFetched) {
              setLoaded(false)
              await getRecipe(recipeId)
              const variants = await getRecipeVariants(recipeId)
              const ids = getIngredientsIds(variants)
              await fetchIngredients(ids)
              setRecipeFetched(true)
              setLoaded(true)
            }
          } catch(e) {
            setHasError(e)
          }
        }
      })()
    }, [ isNew, recipeId, requiermentsFetched, recipeFetched, hasError ]) //eslint-disable-line react-hooks/exhaustive-deps

    if (hasError) {
      const message = _.get(hasError, 'response.data.error.value') ||
      _.get(hasError, 'response.data') ||
       'Oops, Something went wrong!'

      return <Error error={message}/>
    }

    if (isNew && requiermentsFetched) {
      return component()
    }
    return loaded ? component() : <Loading />
  },
)

export default RecipeLoader
